module.exports = __webpack_public_path__ + "img/icon2.d1f648a3.png";